import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
import { defineComponent, onMounted, ref, computed } from "@vue/composition-api";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import { useAccountStoreGetters } from "@Client/@Modules/main/store/account/account-helpers";
import { useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { avatarPlaceholder } from "@Shared/utils/helpers/helpers";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useI18n } from "vue-i18n-composable";
import AgentDetailsLoader from "@Client/@Modules/application-standalone/components/loaders/agent-details-loader.vue";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { LICENSE_TYPE } from "@Client/@Utils/enums";
import NewAppModal from "../../subdomain-interstitial/new-application-modal.vue";
import { logout } from "@Client/@Modules/main/api/account-api";
export default defineComponent({
  name: "FullApplicationSidebar",
  components: {
    ProfileAvatar,
    AgentDetailsLoader,
    NewAppModal
  },
  props: {
    applicationId: {
      type: String,
      required: true
    }
  },
  setup(_, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const loading = ref(true);
    const isEmailTruncated = ref(false);
    const {
      CURRENT_USER_DETAILS,
      CURRENT_ACCOUNT_DETAILS,
      AGENT_ACCOUNT_DETAILS,
      CURRENT_BROKERAGE_DETAILS
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_DETAILS, AccountGetters.CURRENT_ACCOUNT_DETAILS, AccountGetters.AGENT_ACCOUNT_DETAILS, AccountGetters.CURRENT_BROKERAGE_DETAILS]);
    const {
      LOAD_AGENT_ACCOUNT_DETAILS
    } = useAccountStoreActions([AccountActions.LOAD_AGENT_ACCOUNT_DETAILS]);
    const {
      IS_FILL_OUT,
      GUEST_FILL_OUT_CLIENT_DETAILS
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.IS_FILL_OUT, ApplicationStandaloneGetters.GUEST_FILL_OUT_CLIENT_DETAILS]);
    const {
      applicantNameFromId
    } = useApplicantHelpers();
    const tiedBrokerages = CURRENT_BROKERAGE_DETAILS.value.tiedBrokerages;
    const agentAccountDetails = computed(() => {
      var _AGENT_ACCOUNT_DETAIL;
      return _objectSpread(_objectSpread({}, AGENT_ACCOUNT_DETAILS.value), {}, {
        profilePhoto: ((_AGENT_ACCOUNT_DETAIL = AGENT_ACCOUNT_DETAILS.value) == null ? void 0 : _AGENT_ACCOUNT_DETAIL.profilePhoto) || avatarPlaceholder(AGENT_ACCOUNT_DETAILS)
      });
    });
    const currentUserDetails = computed(() => {
      const applicantDetails = IS_FILL_OUT.value ? GUEST_FILL_OUT_CLIENT_DETAILS.value : CURRENT_USER_DETAILS.value;
      const {
        givenName,
        familyName
      } = applicantNameFromId(applicantDetails.username);
      return _objectSpread(_objectSpread({}, applicantDetails), {}, {
        givenName: givenName || applicantDetails.givenName,
        familyName: familyName || applicantDetails.familyName
      });
    });
    const accountType = computed(() => IS_FILL_OUT.value ? t("sidebar.sections.guestFillOut") : tc(`global.doorr.${CURRENT_ACCOUNT_DETAILS.value.accountType}`, 1));
    const licenseType = computed(() => {
      var _agentAccountDetails$, _agentAccountDetails$2, _agentAccountDetails$3, _agentAccountDetails$4;
      return (_agentAccountDetails$ = agentAccountDetails.value) != null && _agentAccountDetails$.licenseType && ((_agentAccountDetails$2 = agentAccountDetails.value) == null ? void 0 : _agentAccountDetails$2.licenseType) !== "blank" && LICENSE_TYPE[(_agentAccountDetails$3 = agentAccountDetails.value) == null ? void 0 : _agentAccountDetails$3.licenseType] ? t(`global.licenseTypes.${LICENSE_TYPE[(_agentAccountDetails$4 = agentAccountDetails.value) == null ? void 0 : _agentAccountDetails$4.licenseType]}`) : null;
    });
    const handleLogout = async () => {
      var _Vue$auth, _Vue$auth$session, _Vue$auth$session$get, _Vue$auth$session$get2;
      const token = (_Vue$auth = Vue.auth) == null ? void 0 : (_Vue$auth$session = _Vue$auth.session) == null ? void 0 : _Vue$auth$session.get == null ? void 0 : (_Vue$auth$session$get = _Vue$auth$session.get()) == null ? void 0 : (_Vue$auth$session$get2 = _Vue$auth$session$get.xData) == null ? void 0 : _Vue$auth$session$get2.ref;
      try {
        if (token) {
          await logout(token);
        }
      } catch (e) {
        console.error("Logout failed", e);
      }
      Vue.auth.session.end();
    };
    const copyEmail = email => {
      navigator.clipboard.writeText(email);
    };
    const getIsEmailTruncated = () => {
      const element = document.getElementById("agentEmail");
      return !!element && element.offsetWidth < element.scrollWidth;
    };
    onMounted(async () => {
      loading.value = true;
      await LOAD_AGENT_ACCOUNT_DETAILS({
        hardReload: true
      });
      isEmailTruncated.value = getIsEmailTruncated();
      loading.value = false;
    });
    const addNewApp = ref();
    const handleNewAppModal = () => {
      var _addNewApp$value;
      addNewApp == null ? void 0 : (_addNewApp$value = addNewApp.value) == null ? void 0 : _addNewApp$value.openModal();
    };
    const handleRefreshPage = () => {
      emit("refresh");
    };
    return {
      tiedBrokerages,
      addNewApp,
      handleNewAppModal,
      handleRefreshPage,
      currentUserDetails,
      accountType,
      agentAccountDetails,
      licenseType,
      handleLogout,
      copyEmail,
      isEmailTruncated,
      IS_FILL_OUT,
      loading
    };
  }
});